import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

type Props = {
  content: CmsApiDocument;
};

export function getContentShowListingCounts({ content }: Props): boolean {
  return Boolean(content.heroSearch?.showCounts);
}
